import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurrencyDollarCircle1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "currency-dollar-circle" }), /* @__PURE__ */ _jsx("path", { d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm1.464,18.587a.251.251,0,0,0-.214.248V19.6a1.25,1.25,0,0,1-2.5,0v-.705a.249.249,0,0,0-.25-.25H9.353a1.25,1.25,0,0,1,0-2.5h3.588a1.118,1.118,0,0,0,.415-2.156l-3.64-1.457a3.605,3.605,0,0,1,.82-6.92.25.25,0,0,0,.214-.247V4.6a1.25,1.25,0,0,1,2.5,0v.706a.25.25,0,0,0,.25.25h1.147a1.25,1.25,0,0,1,0,2.5H11.059a1.117,1.117,0,0,0-.415,2.155l3.64,1.457a3.605,3.605,0,0,1-.82,6.92Z" })]
});
export default SvgCurrencyDollarCircle1;
